module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("News")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v("Posted 2 days ago")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("News Story Title")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v("Posted September 2, 2016")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("News Story Title")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-8 col-lg-9"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_vm._v("Posted 2015")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b', [_vm._v("News Story Title")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-604fde3d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/MediaNewsPage.vue
// module id = 1438
// module chunks = 1